export default (theme) => ({
  featureFlagAlertContainer: {
    alignItems: 'flex-start',
    backgroundColor: '#FEFAF5',
    border: '1px solid rgba(242, 153, 62, .25)',
    borderRadius: 20,
    display: 'flex',
    gap: 16,
    padding: '34px 24px',
    width: '100%',
  },
  featureFlagAlertIcon: {
    flexShrink: 0,
    height: 48,
    position: 'relative',
    width: 48,
  },
  featureFlagAlertContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  featureFlagAlertContentTitle: {
    color: '#000000',
    fontFamily: theme.typography.fontFamily,
    fontSize: 20,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
    margin: 0,
    whiteSpace: 'pre-line',

    [theme.breakpoints.up('lg')]: {
      fontSize: 21,
    },
  },
  featureFlagAlertContentText: {
    color: '#000000',
    fontFamily: theme.typography.fontFamily,
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 400,
    letterSpacing: 0.5,
    lineHeight: 'normal',
    margin: 0,
    whiteSpace: 'pre-line',

    [theme.breakpoints.up('lg')]: {
      fontSize: 16,
    },
  },
});
